import { canRecoverProductIndex } from '~/utils/product-index-recovery'

export default defineNuxtRouteMiddleware(() => {
  const store = useStore()
  if (!canRecoverProductIndex(store.auth?.user?.permissions))
    return navigateTo('/403')
})
